// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"745047eb","427":"b4ec504b"}[chunkId] + ".chunk.js";
};